import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
/**
 * The one react-router renderer for Specra hrefs: pass it as `renderLink` to
 * SpecraLink, SpecraMetricStrip, SpecraActionList, the sidebars and hub cards,
 * so an in-app href navigates without a page load. Module-level, so its
 * identity is stable and no caller needs a useCallback.
 */ export function renderRouterLink({ href, children, ...props }) {
    return /*#__PURE__*/ _jsx(Link, {
        to: href,
        ...props,
        children: children
    });
}
